import ErrorSummaryScreenDal from '../dal/ErrorSummaryScreen';

class ErrorSummaryScreen {
    static async getMonthData(URL, requestOption) {
        return await ErrorSummaryScreenDal.getMonthData(URL, requestOption);
    }
}
export default ErrorSummaryScreen;